import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate

function SurgeriesPage() {
  const [surgeries, setSurgeries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // 2. Initialize hook

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_BASE_URL + "/surgeries")
      .then(response => {
        setSurgeries(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching surgeries:", error);
        setLoading(false);
      });
  }, []);

  // 3. Function to handle clicks
  const handleCardClick = (title) => {
    // Map the Surgery Title -> The actual Specialty URL keyword
    let specialtyLink = '';

    switch (title) {
      case "Heart Surgery":
        specialtyLink = "cardiology";
        break;
      case "Orthopedic Surgery":
        specialtyLink = "orthopedic-surgeon";
        break;
      case "Neurosurgery":
        specialtyLink = "neurologist";
        break;
      case "Plastic Surgery":
        specialtyLink = "dermatologist"; // Or plastic surgeon if you have one
        break;
      case "Eye Surgery":
        specialtyLink = "eye-specialist";
        break;
      case "Dental Surgery":
        specialtyLink = "dentist";
        break;
      default:
        specialtyLink = "";
    }

    if (specialtyLink) {
      navigate(`/specialty/${specialtyLink}`);
    } else {
      // Fallback if no specific doctor category exists
      alert(`No specific doctors found for ${title} yet.`);
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section text-center text-white py-3" >
        <div className="container">
          <h1 className="display-4 fw-bold" style={{ fontSize: '2.5rem' }}>Surgeries & Treatments</h1>
          <p className="lead" style={{ fontSize: '1.1rem' }}>Providing advanced surgical solutions with modern facilities and expert care.</p>
        </div>
      </section>

      {/* Surgery Categories */}
      <section className="py-5">
        <div className="container">

          {loading ? (
            <div className="text-center"><h3>Loading treatments...</h3></div>
          ) : (
            <div className="row g-4">
              {surgeries.map((surgery) => (
                <div key={surgery._id} className="col-md-4">
                  <div
                    className="card surgery-card shadow-sm h-100 border-0"
                    // 4. Add Click Event and Pointer Cursor
                    onClick={() => handleCardClick(surgery.title)}
                    style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img
                      src={surgery.image.startsWith('http') ? surgery.image : `/images/surgeries/${surgery.image}`}
                      className="card-img-top"
                      alt={surgery.title}
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <div className="card-body">
                      <h5 className="card-title fw-bold text-primary">{surgery.title}</h5>
                      <p className="card-text text-muted">{surgery.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>
    </>
  );
}

export default SurgeriesPage;